import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {KostStateType} from 'module/Kost/reducer/KostReducer'

export const selSomeKostAuswertungVisible = selPropGen(PropID.kostAuswertungButton, v => Boolean(v && v !== 'N'))
export const selKostAuswertungCFDefs = (state: KostStateType) => state.Kost.auswertungCFDefs || []